import { useCallback } from "react";
import MusicTab from "./MusicTab/MusicTab";
import ImagesTab from "./ImagesTab/ImagesTab";
import VoiceoverTab from "./VoiceoverTab/VoiceoverTab";
import TabNavigation, { editorPanelTabs } from "./TabNavigation/TabNavigation";
import OverlaysTab from "./OverlaysTab/OverlaysTab";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import ScriptWriter from "./VoiceoverTab/ScriptWriter";

export default function EditorPanel() {
  const editorPanelState = useEditorStore((state) => state.editorPanelState);
  const voiceoverTabState = useEditorStore((state) => state.voiceoverTabState);
  const voiceOvers = useEditorStore((state) => state.voiceOvers);
  const voiceOverForm = useEditorStore((state) => state.voiceOverForm);

  const updateEditorPanelState = useEditorStore(
    (state) => state.service.updateEditorPanelState,
  );
  const updateOverlaysTabState = useEditorStore(
    (state) => state.service.updateOverlaysTabState,
  );
  const updateVoiceoverTabState = useEditorStore(
    (state) => state.service.updateVoiceoverTabState,
  );

  const seekToScene = useEditorStore((state) => state.service.seekToScene);

  const handleTabChange = useCallback(
    (tab: (typeof editorPanelTabs)[number]["value"]) => {
      if (tab === "overlays") {
        updateOverlaysTabState((state) => {
          state.currentTab = "elements";
          state.currentElement = null;
        });

        seekToScene("mainScene");
      }

      if (tab === "voiceover") {
        const hasExistingVoiceOvers = voiceOvers.length > 0;
        const hasScriptContent = voiceOverForm.script.trim().length > 0;

        if (hasExistingVoiceOvers || hasScriptContent) {
          updateVoiceoverTabState((state) => {
            state.view = "CREATE_VOICEOVER";
          });
        }
      }

      updateEditorPanelState((state) => {
        state.currentTab = tab;
      });
    },
    [
      updateOverlaysTabState,
      updateVoiceoverTabState,
      updateEditorPanelState,
      voiceOverForm,
      voiceOvers,
      seekToScene,
    ],
  );

  return (
    <div className="relative mb-3 flex flex-[0_0_auto]">
      {voiceoverTabState.view === "SCRIPT_WRITER" &&
        editorPanelState.currentTab === "voiceover" && <ScriptWriter />}
      <TabNavigation
        activeTab={editorPanelState.currentTab}
        onTabChange={handleTabChange}
      />
      <div className="w-3"></div>
      <div className="h-full w-150 overflow-hidden rounded-2xl bg-white shadow-card">
        <div
          key={editorPanelState.currentTab}
          className="h-full w-full animate-fade-in"
        >
          {editorPanelState.currentTab === "images" && <ImagesTab />}
          {editorPanelState.currentTab === "voiceover" && <VoiceoverTab />}
          {editorPanelState.currentTab === "music" && <MusicTab />}
          {editorPanelState.currentTab === "overlays" && <OverlaysTab />}
        </div>
      </div>
    </div>
  );
}
